import { PartnerAccountTransactions, Transaction, TransactionsHistoryResponse, TransactionsLists } from 'vopay';

/**
 * One `/partner/account/transactions` row as the Transaction History list reads it. The route's own
 * `AccountID` is the internal row id; the VoPay account ID the portal keys on (and `/account/transactions`
 * returns as `AccountID`) is the row's `Username`. The route carries no refund-side, fee, wallet or
 * type-code fields, which read as the account route leaves them on a row that has none.
 */
function toTransactionsList(transaction: Transaction): TransactionsLists {
  return {
    AccountID: transaction.Username,
    AccountName: transaction.AccountName,
    ChildTransactionIDs:
      typeof transaction.ChildTransactionIDs === 'string'
        ? transaction.ChildTransactionIDs.split(',').filter(Boolean)
        : Object.values(transaction.ChildTransactionIDs),
    ClientAccountID: transaction.ClientAccountID,
    ClientReferenceNumber: transaction.ClientReferenceNumber,
    CreditAmount: transaction.CreditAmount,
    Currency: transaction.Currency,
    DebitAmount: transaction.DebitAmount,
    FullName: transaction.FullName,
    HoldAmount: transaction.HoldAmount,
    IsRefunded: transaction.IsRefunded === '1',
    IsRefund: false,
    LastModified: transaction.LastModified,
    Notes: transaction.Notes,
    ParentTransactionID: transaction.ParentTransactionID,
    ELinxRequestID: transaction.ELinxRequestID,
    ScheduledTransactionID: transaction.ScheduledTransactionID,
    TransactionDateTime: transaction.TransactionDateTime,
    TransactionErrorCode: transaction.TransactionErrorCode,
    TransactionFailureReason: transaction.TransactionFailureReason,
    TransactionFlag: transaction.TransactionFlag,
    TransactionID: transaction.TransactionID,
    TransactionStatus: transaction.TransactionStatus,
    TransactionType: transaction.TransactionType,
    SettlementDate: transaction.SettlementDate,
    PaymentRailID: transaction.PaymentRailID,
    ConvenienceFeeAmount: '',
    GLCode: '',
    TransactionTypeCode: '',
    WalletName1: '',
    WalletName2: '',
  };
}

/** The route's response in the shape `useFetchTransactionsHistory` returns; the list is keyed by index on the wire. */
export default function toTransactionsHistoryResponse(
  response: PartnerAccountTransactions,
): TransactionsHistoryResponse {
  const transactions = Object.values(response.Transactions ?? {}).map(toTransactionsList);

  return {
    Success: response.Success,
    ErrorMessage: response.ErrorMessage,
    CSVFile: response.CSVFile,
    PDFFile: response.PDFFile,
    NumberOfRecords: response.TransactionsCount ?? transactions.length,
    Transactions: transactions,
    // Absent on a CSV export, which the list does not paginate.
    PaginationMetaData: response.PaginationMetaData ?? { Limit: 0, Offset: 0, TotalRecords: transactions.length },
  };
}
